<template>
  <div class="selectPart">
    <van-sticky>
      <div class="header">
        <div class="headerIcon">
          <van-icon name="arrow-left" color="#fff" @click="returnIndex" />
          <van-search v-model="value" placeholder="查找" />
        </div>
      </div>
    </van-sticky>
    <div class="vanIndexBar">
      <van-index-bar v-for="(item,index) in textList" :key="index">
        <van-index-anchor :index="item.name" />
        <van-radio-group v-model="radio">
          <van-cell-group v-for="(list,index) in item.lists" :key="index">
            <van-cell :title="list.projectName" clickable @click="radio = list.id">
              <template #right-icon>
                <van-radio :name="list.id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-index-bar>
    </div>
    <div class="textSure" @click="sureAdd()">
      <div class="selectSure">确定</div>
    </div>
  </div>
</template>
<script>
import {
  findByProjectIdList,
} from '@/axios/api'
export default {
  data() {
    return {
      value: "",
      radio: '',
      lists: [],
      listIndex: "",
      textList: [{
        name: 'A',
        radio: '',
        lists: [{
          projectName: '单选框1',
          id: '1'
        },
        {
          projectName: '单选框2',
          id: '2'
        },
        ]
      },
      {
        name: "B",
        radio: '',
        lists: [{
          projectName: '单选框3',
          id: '3'
        },
        {
          projectName: '单选框4',
          id: '4'
        },
        ]
      }
      ],

    };
  },
  created() {
    console.log(this.$route.params.item);
    console.log(this.$route.params.index);
    this.findprojectList()
    this.listIndex = this.$route.params.index
  },
  methods: {
    returnIndex() {
      this.$router.push("/addAppointment");
    },
    findprojectList() {
      findByProjectIdList({
        ids: '',
        projectType: '',
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
        cityCode: localStorage.getItem('cityCode'),
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            // console.log('0000')
            this.lists = res.data
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 确定提交参数
    sureAdd() {
      this.$router.push({
        name: "addAppointment",
        params: {
          radio: this.radio,
          list: this.lists,
          listIndex: this.listIndex
        },
      });
    }
    // item.operationStatus==1?'初诊':item.operationStatus==2?'复诊':''
  },
};

</script>
<style scoped>
@import "../../assets/css/selectPart.css";
</style>



// WEBPACK FOOTER //
// src/components/page/selectPart.vue